// React
import { useMemo } from "react"

// Countries list
import {
	getCountryCode,
	getCountryDataList,
	getEmojiFlag,
	type ICountry,
} from "countries-list"

// Translate
import { useTrans } from "@/lib/i18n"

// API types
import { CoreLocationCountryChoices } from "@/api/graphql/types"

export interface Country extends ICountry {
	code: string
}

// Create a list of countries with their code and name
export const countries = getCountryDataList().map((country) => {
	return {
		...country,
		code: country.iso2,
	} as Country
})

/**
 * React hook to get core location country choices with reactive locale updates
 * Check which countries are allowed in the app according to this enum list CoreLocationCountryChoices
 * Returns a sorted list of allowed countries with translated names
 */
export function useOnlyCoreLocationCountryChoices() {
	const t = useTrans("locale")

	return useMemo(() => {
		return countries
			.filter((country) =>
				Object.values(CoreLocationCountryChoices).includes(
					country.code as CoreLocationCountryChoices,
				),
			)
			.map((country) => ({
				code: country.code,
				name: t(`country.${country.code}`),
			}))
			.sort((a, b) => a.name.localeCompare(b.name))
	}, [t])
}

// Re-export
export { getCountryCode, getCountryDataList, getEmojiFlag }
